import { useMemo } from 'react';

import { useEdition } from '@/lib/auth/useEdition';
import { type NavGroup } from '@/config/navigation';
import { usePermissions } from '@/features/permissions';

export function useFilteredNavigation(navGroups: NavGroup[]): NavGroup[] {
  const { can, canAny } = usePermissions();
  const edition = useEdition();

  return useMemo(() => {
    return navGroups
      .filter((group) => !group.requiredEdition || group.requiredEdition === edition)
      .map((group) => ({
        ...group,
        items: group.items.filter((item) => {
          if (item.requiredEdition && item.requiredEdition !== edition) {
            return false;
          }
          if (item.requiredPermission) {
            return can(item.requiredPermission);
          }
          if (item.requiredPermissions) {
            return canAny(...item.requiredPermissions);
          }
          return true;
        }),
      }))
      .filter((group) => group.items.length > 0);
  }, [navGroups, can, canAny, edition]);
}
